module.exports = {
    'Init': require('./init'),
    'UpdateVideoSize': require('./update-video-size')
};